import { TrashCartPopUpIcon } from '@/components/icons';
import useHandleCart from '@/hooks/cart/useHandleCart';
import CloseIcon from '../icons/close-icon';

const DeleteCartItem = ({ className, item_id, fromCartPage = false }) => {
  const { deleteItemFromCart, loading } = useHandleCart();
  return (
    <button
      onClick={() => deleteItemFromCart(item_id)}
      disabled={loading === 'deleting'}
      className={
        className ||
        'order-2 flex h-fit shrink-0 cursor-pointer rounded-sm border border-[#eee] p-1 disabled:cursor-not-allowed disabled:opacity-75'
      }
    >
      {loading === 'deleting' ? (
        <span className='size-4 animate-spin rounded-full border-t border-r border-black' />
      ) : fromCartPage ? (
        <CloseIcon className='size-6 max-sm:size-3' />
      ) : (
        <TrashCartPopUpIcon className='text-primary' />
      )}
    </button>
  );
};

export default DeleteCartItem;
